<div class="f-cont ">
  <div class="filter-container " *ngFor="let item of filterArr;let i=index">
    <div class="d-flex justify-content-between ">
      <div class="d-flex flex-wrap w-100 align-items-center">
        <mat-select class="form-control sources main-selection select-class me-2 me-sm-3 " placeholder="Select Field"
          (selectionChange)="onFilterChange(i,$event)" [(ngModel)]="item.filter_value">
          <mat-option [value]="fval.key_val" *ngFor="let fval of fieldCol">{{fval.key_name}}</mat-option>
        </mat-select>

        <mat-select class="form-control sources  select-class me-2 me-sm-3 " placeholder="Select Criteria"
          [(ngModel)]="item.contains" (selectionChange)="onTypeChange(i)">
          <mat-option [value]="val.val" *ngFor="let val of  item.array_type">{{val.key}}</mat-option>
        </mat-select>

        <div class="in-container ms-lg-3 me-lg-0 me-3" *ngIf="(item.contains!='') && (item.filter_value!='')">
          <input type="text" class="form-control filter-in " [(ngModel)]="item.type_value"
            *ngIf="item.filter_type=='text'" placeholder="Type (comma separated value)" [value]="item.type_value"
            (change)="onContainValueChange($event,item)">
          <mat-select class="form-control   select-class" placeholder="Select Dept"
            *ngIf="item.filter_type=='select' && !item.arr" [(ngModel)]="item.type_value"
            (selectionChange)="onContainValueChange($event,item)">
            <mat-option *ngFor="let dep of departmentArr" [value]="dep.cd_i">{{dep.dep }}</mat-option>
          </mat-select>
          <!--1.If the filter is being used for the calendar then only the below select box will appear or else it wouldn't be used. The key_name value i am 
          setting from the criteria change function for the calendar filter
          2. User can select multiple values if searching for the calendar filter but not if the value is category as based on category sub category array
          is mapped. Hence don't allow to multi select for the category and enable it for all other use cases.  -->
          <!-- <mat-select class="form-control   select-class" placeholder="Select" [multiple]="item.key_name!='j_c'"
            *ngIf="item.filter_type=='select'  && item.arr " [(ngModel)]="item.type_value"
            (selectionChange)="onContainValueChange($event,item,'j_c')">
            <mat-option *ngFor="let dep of item.arr" [value]="dep[item.filter_value]">{{dep.name }}</mat-option>
          </mat-select> -->
          <mat-select class="form-control select-class" placeholder="Select" [multiple]="true"
            *ngIf="item.filter_type == 'select' && item.arr && item.key_name != 'j_c'" [(ngModel)]="item.type_value"
            (selectionChange)="onContainValueChange($event, item)">

            <!-- Search Field -->

            <input class="form-control mt-0 m-auto mb-2" matInput placeholder="Search..." [(ngModel)]="item.searchText" (click)="$event.stopPropagation()"
              (keyup)="$event.stopPropagation()" />

            <!-- Filtered List -->
            <mat-option *ngFor="let dep of getFilteredList(item)" [value]="dep[item.filter_value]">
              {{ dep.name }}
            </mat-option>
          </mat-select>

          <mat-select class="form-control select-class" placeholder="Select" [multiple]="false"
          *ngIf="item.filter_type == 'select' && item.arr && item.key_name == 'j_c'" [(ngModel)]="item.type_value"
          (selectionChange)="onContainValueChange($event, item, 'j_c')">

          <!-- Search Field -->
          <input class="form-control mt-0 m-auto mb-2" matInput placeholder="Search..." [(ngModel)]="item.searchText" (click)="$event.stopPropagation()"
            (keyup)="$event.stopPropagation()" />

          <!-- Filtered List -->
          <mat-option *ngFor="let dep of getFilteredList(item)" [value]="dep[item.filter_value]">
            {{ dep.name }}
          </mat-option>
        </mat-select>


          <div *ngIf="item.filter_type=='date'" class="dp-cont">
            <input class="form-control filter-in" matInput [matDatepicker]="picker" [(ngModel)]="item.type_value"
              (dateChange)="onContainValueChange($event,item)">
            <mat-datepicker-toggle matIconSuffix [for]="picker" class="dp-b"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>

        <mat-select class="form-control select-class ms-3" placeholder="Select Subcategory" multiple
          [(ngModel)]="item.sub_val" *ngIf="item.filter_type=='select'  && item.arr  && item.filter_value=='j_c'"
          (selectionChange)="onContainValueChange($event,item)">
          <mat-option *ngFor="let dep of item.sub_a" [value]="dep.s_n">{{dep.s_n}}</mat-option>
        </mat-select>

        <span *ngIf="filterArr.length>1 && i!=(filterArr.length-1)" class="d-flex align-items-center">
          <select name="operand" id="w" [(ngModel)]="operand" class="ms-lg-3 form-control select-class operand-class"
            (change)="onOperand($event)">
            <option value="and">and</option>
            <option value="or">or</option>
          </select>
        </span>
        <div class="m-15 ms-2 d-flex align-items-center">
          <i class="material-icons text-danger cursor-pointer" (click)="onDeleterFilter(i)">close</i>
        </div>
      </div>
    </div>
  </div>
  <div class="primary-color  link-txt cursor-pointer" *ngIf="filterArr.length>0">
    <span (click)="onAddFilter()"> <i class="fas fa-plus "></i> Add Another Filter</span>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>